import React, { useState } from 'react';
import '../styles/styles.css';

const PodcastOptionsModal = ({ visible, onConfirm, onCancel }) => {
    const [durationMinutes, setDurationMinutes] = useState('5'); // Default to 5 minutes
    const [error, setError] = useState('');

    const handleConfirm = () => {
        const duration = parseInt(durationMinutes, 10);
        if (isNaN(duration) || duration < 1 || duration > 30) {
            setError('Please enter a duration between 1 and 30 minutes.');
            return;
        }
        setError('');
        onConfirm({ durationMinutes: duration });
    };

    const handleCancel = () => {
        onCancel();
    };

    if (!visible) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container podcast-options-modal">
                <h2 className="modal-title">Generate Podcast</h2>
                
                <div className="input-container">
                    <label className="modal-label">
                        Podcast Duration (minutes)
                    </label>
                    <input
                        className="text-input"
                        type="number"
                        value={durationMinutes}
                        onChange={(e) => {
                            setDurationMinutes(e.target.value);
                            setError('');
                        }}
                        placeholder="e.g. 5"
                        min="1"
                        max="30"
                        step="1"
                    />
                    <p className="modal-help-text">
                        Choose how long you want the podcast to be (1–30 minutes recommended).
                    </p>
                </div>

                {error && <p className="error-text">{error}</p>}

                <div className="modal-footer">
                    <button
                        type="button"
                        className="button confirm-button"
                        onClick={handleConfirm}
                    >
                        Generate Podcast
                    </button>
                    <button
                        type="button"
                        className="button button--ghost"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PodcastOptionsModal;